import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SessionGroupRow from './SessionGroupRow';
import { parseDeviceInfo } from '../../utils/parseDeviceInfo';
import language from '../../variables/language';

function groupSessions(sessions) {
  const groups = new Map();
  for (const session of sessions) {
    const info = parseDeviceInfo(session.device);
    if (!groups.has(info.groupKey)) {
      groups.set(info.groupKey, { groupKey: info.groupKey, label: info.label, sessions: [] });
    }
    groups.get(info.groupKey).sessions.push(session);
  }
  const result = Array.from(groups.values());
  for (const group of result) {
    group.sessions.sort((a, b) => (b.lastActivity || '').localeCompare(a.lastActivity || ''));
  }
  result.sort((a, b) => (b.sessions[0]?.lastActivity || '').localeCompare(a.sessions[0]?.lastActivity || ''));
  return result;
}

export default function SessionsPanel() {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [status, setStatus] = useState('loading');
  const lang = language[language.lang];

  useEffect(() => {
    axios.get('/api/sessions', { withCredentials: true })
      .then((response) => { setSessions(response.data || []); setStatus('done'); })
      .catch((err) => {
        if (err.response && err.response.status === 401) navigate('/login');
        else setStatus('error');
      });
  }, [navigate]);

  const handleDelete = (id) => {
    if (!window.confirm(lang.sessionsPanel.removeConfirm)) return;
    axios.delete('/api/sessions/' + id, { withCredentials: true })
      .then(() => setSessions((prev) => prev.filter((s) => s.id !== id)))
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          setSessions((prev) => prev.filter((s) => s.id !== id));
        }
      });
  };

  const groups = groupSessions(sessions);

  return (
    <div className="settings-section">
      <h3>{lang.logging}</h3>
      {status === 'loading' ? <p className="sessions-empty">...</p> : ''}
      {status === 'error' ? <p className="sessions-empty">{lang['Empty list']}</p> : ''}
      {status === 'done' && groups.length === 0 ? <p className="sessions-empty">{lang['Empty list']}</p> : ''}
      {status === 'done' && groups.length > 0 ? (
        <ul className="session-group-list">
          {groups.map((group) => (
            <SessionGroupRow key={group.groupKey} group={group} onDelete={handleDelete} />
          ))}
        </ul>
      ) : (
        ''
      )}
    </div>
  );
}
